import React, { useRef } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import $ from "jquery";

const UpdateVehicleDetailsModal = ({
  selectedRowsData,
  updateHandleChange,
  getData,
  setRowAddData,
  rowAddData,
}) => {
  // console.log("selectedRowsData", selectedRowsData)
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");

  const updateData = async (e) => {
    const closeModal = () => {
      $(".custon-close-button-color").trigger("click");
    };
    e.preventDefault();
    const { id, vehicle_number } = selectedRowsData;
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/vehicle-details/${user_id}`;

    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        vehicle_number,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
        // navigate("/dashboard");
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="editModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Vehicle Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Company</h4> */}
                    <form className="form-sample" onSubmit={updateData}>
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="vehicle_number">
                              Vehicle Number
                            </label>

                            <input
                              type="text"
                              className="form-control"
                              name="vehicle_number"
                              id="vehicle_number"
                              placeholder="Vehicle Number"
                              onChange={updateHandleChange}
                              value={selectedRowsData.vehicle_number}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={updateData}
                      >
                        Update
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateVehicleDetailsModal;
